import { render, staticRenderFns } from "./CheckTireContractPage.vue?vue&type=template&id=ccfbca42"
import script from "./CheckTireContractPage.vue?vue&type=script&lang=ts"
export * from "./CheckTireContractPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports